import { Injectable } from '@angular/core';
import { FilterSelectorBaseService } from '@shared/services/filter-selector-base.service';
import { ValuationCriteriaSearchModel } from '@valuation/models';

@Injectable({
  providedIn: 'root'
})
export class ValuationFilterSelectorService extends FilterSelectorBaseService<ValuationCriteriaSearchModel> {}
